App.filter('isOver65FromIdentifier', function () {
    return function (identifier) {
        identifier = identifier || '';

        if (identifier) {

            if (correct(identifier)) {
            	var ssn = identifier.split("");
            	var yearShort = parseInt(identifier.substring(0,2), 10);
            	var month = parseInt(identifier.substring(2,4),10);
            	var day = parseInt(identifier.substring(4,6),10);

            	var date = changeDate(yearShort, month);

            	var precise = date['year'] + 65 + '/' + date['month'] + '/' + day;
            	var preciseMiliseconds = new Date(precise).getTime();
            	var nowMiliseconds = new Date().getTime();

            	if (preciseMiliseconds > nowMiliseconds) {
            		return false;
            	} else {
            		return true;
            	}

            } else {
            	return false;
            }
        }
        return false;
    };

    function correct(identifier) {
    	var reg = /^[0-9]{11}$/;    
		if (reg.test(identifier)) {      
			var ssn = identifier.split("");
			var weights = [1,3,7,9], sum = 0, control = 0;

			for (var i = 0; i < 10; i++) {
				sum += ssn[i] * weights[i%4];
			}

			sum = sum % 10;
			if (sum != 0) {
				control = 10 - sum;
			}      

			if (control == ssn[10]) {
				return true;
			} else {
				return false;
			}     
		}
		else {    
			return false;      
		} 
    }

    function changeDate(y, m) {
		if(m > 80) {
			y += 1800;
			m -= 80;
		} else if(m > 60) {
			y += 2200;
			m -= 60;
		} else if (m > 40) {
			y += 2100;
			m -= 40;
		} else if (m > 20) {
			y += 2000;
			m -= 20;
		} else {
			y += 1900;
		}

		var date = {
			year: y, 
			month: m
		};

		return date;
	}
})